<template>
  <div>
    <AjaxSelect
      ref="ajaxSelect"
      v-model="newValue"
      :prop-class="propClass"
      :disabled="disabled"
      :api="api"
      :query="query"
      :map-fn="mapFn"
      :allowEmptySearch="allowEmptySearch"
      :ignored="ignored"
      :remove-keys="removeKeys"
      :clearable="false"
    />
    <div class="line" v-for="(v, i) of value">
      <button class="btn btn-secondary" @click="remove(i)">
        <svgicon src="/icon/close.svg" :height="8" :width="8"></svgicon>
      </button> {{itemToString(v)}}
    </div>
  </div>
</template>

<script>
  import AjaxSelect from "@/components/tools/AjaxSelect.vue";

  export default {
    name: "AjaxSelectMulti",

    components: { AjaxSelect },

    props: {
      value: Array,
      propClass: {
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      api: {
        type: String
      },
      query: {
        type: Object,
        default: () => ({})
      },
      mapFn: {
        type: Function,
        default: null
      },
      allowEmptySearch: {
        type: Boolean,
        default: false
      },
      removeKeys: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        newValue: { id: null }
      }
    },

    computed: {
      ignored() {
        return this.value.map(v => v.id)
      }
    },

    watch: {
      'newValue.id'() {
        if (this.newValue && this.newValue.id !== null) {
          this.value.push(this.clone(this.newValue));
          this.newValue = { id: null };
        }
      }
    },

    methods: {
      clone(obj) {
        return JSON.parse(JSON.stringify(obj))
      },
      itemToString(item) {
        let tmp = this.mapFn ? this.mapFn(item) : item.name;
        return typeof tmp === 'object' ? this.$to(tmp) : tmp;
      },
      remove(index) {
        this.value.splice(index, 1)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .line {
    margin-top: 5px;
  }
  .btn {
    fill: var(--primary-color);
    border: 1px solid var(--primary-color);
    padding: 5px;
    margin-right: 5px;
  }
</style>
